import * as actionTypes from '../actions';
import moment from 'moment';
import {reduce, find, propEq} from 'ramda';
import {convertAgeToDateOfBirth} from "../../shared/common";

const initialState = {
    clientInfo: {
        clientId: null,
        firstName: {
            value: "",
            invalid: false
        },
        lastName: {
            value: "",
            invalid: false
        },
        dateOfBirth: {
            value: moment().subtract(1, "days"),
            invalid: false
        },
        age: {
            value: 0,
            invalid: false
        },
        state: {
            value: "NONE",
            invalid: false
        }
    },
    accountInfo: {
        value: 0.0,
        invalid: false
    },
    allocation: {
        isDefault: true,
        allocationId: "CHOOSE",
        allocationName: "Default Allocation",
        invalid: false,
        assets: [
            {
                assetId: 1,
                name: "Category 1",
                sortOrder: 1,
                value: 0.0,
                children: [
                    {
                        assetId: 1,
                        name: "Asset 1",
                        sortOrder: 1,
                        value: 0.0
                    },
                    {
                        assetId: 2,
                        name: "Asset 2",
                        sortOrder: 2,
                        value: 0.0
                    },
                    {
                        assetId: 3,
                        name: "Asset 3",
                        sortOrder: 3,
                        value: 0.0
                    },
                    {
                        assetId: 4,
                        name: "Asset 4",
                        sortOrder: 4,
                        value: 0.0
                    },
                    {
                        assetId: 5,
                        name: "Asset 5",
                        sortOrder: 5,
                        value: 0.0
                    }]
            },
            {
                assetId: 2,
                name: "Category 2",
                sortOrder: 2,
                value: 0.0,
                children: [{
                    assetId: 1,
                    name: "Asset 1",
                    sortOrder: 1,
                    value: 0.0
                },
                    {
                        assetId: 2,
                        name: "Asset 2",
                        sortOrder: 2,
                        value: 0.0
                    },
                    {
                        assetId: 3,
                        name: "Asset 3",
                        sortOrder: 3,
                        value: 0.0
                    },
                    {
                        assetId: 4,
                        name: "Asset 4",
                        sortOrder: 4,
                        value: 0.0
                    },
                    {
                        assetId: 5,
                        name: "Asset 5",
                        sortOrder: 5,
                        value: 0.0
                    }]
            },
            {
                assetId: 3,
                name: "Category 3",
                sortOrder: 3,
                value: 0.0,
                children: [{
                    assetId: 1,
                    name: "Asset 1",
                    sortOrder: 1,
                    value: 0.0
                },
                    {
                        assetId: 2,
                        name: "Asset 2",
                        sortOrder: 2,
                        value: 0.0
                    },
                    {
                        assetId: 3,
                        name: "Asset 3",
                        sortOrder: 3,
                        value: 0.0
                    },
                    {
                        assetId: 4,
                        name: "Asset 4",
                        sortOrder: 4,
                        value: 0.0
                    },
                    {
                        assetId: 5,
                        name: "Asset 5",
                        sortOrder: 5,
                        value: 0.0
                    }]
            },
            {
                assetId: 4,
                name: "Category 4",
                sortOrder: 4,
                value: 0.0,
                children: [{
                    assetId: 1,
                    name: "Asset 1",
                    sortOrder: 1,
                    value: 0.0
                },
                    {
                        assetId: 2,
                        name: "Asset 2",
                        sortOrder: 2,
                        value: 0.0
                    },
                    {
                        assetId: 3,
                        name: "Asset 3",
                        sortOrder: 3,
                        value: 0.0
                    },
                    {
                        assetId: 4,
                        name: "Asset 4",
                        sortOrder: 4,
                        value: 0.0
                    },
                    {
                        assetId: 5,
                        name: "Asset 5",
                        sortOrder: 5,
                        value: 0.0
                    }]
            },
            {
                assetId: 5,
                name: "Category 5",
                sortOrder: 5,
                value: 0.0,
                children: [{
                    assetId: 1,
                    name: "Asset 1",
                    sortOrder: 1,
                    value: 0.0
                },
                    {
                        assetId: 2,
                        name: "Asset 2",
                        sortOrder: 2,
                        value: 0.0
                    },
                    {
                        assetId: 3,
                        name: "Asset 3",
                        sortOrder: 3,
                        value: 0.0
                    },
                    {
                        assetId: 4,
                        name: "Asset 4",
                        sortOrder: 4,
                        value: 0.0
                    },
                    {
                        assetId: 5,
                        name: "Asset 5",
                        sortOrder: 5,
                        value: 0.0
                    }]
            }
        ]
    },
    allocationList: [],
    IP7: {
        percentageAllocation: {
            value: 0.0,
            invalid: false
        },
        indexAllocation: {
            yr: 0.0,
            sandp: 50.0,
            sandrcntl: 0.0,
            retiree: 0.0,
            interestRate: 0.0,
            indexEAFE: 50.0,
            barclay: 0.0,
            total: 100.0,
            invalid: false
        }
    },
    IndexAchiever: {
        percentageAllocation: {
            value: 0.0,
            invalid: false
        },
        indexAllocation: {
            sp500Minus10Percentage: 0.0,
            sp500OneYear50Percentage: 0.0,
            sp500OneYear10Percentage: 0.0,
            sp500SixYear10Percentage: 0.0,
            eafeOneYear50Percenpage: 0.0,
            eafeOneYear10Percenpage: 0.0,
            realEstateOneYear50Percentage: 0.0,
            realEstateOneYear10Percentage: 0.0,
            spdrOneYear50Percentage: 0.0,
            spdrOneYear10Percentage: 0.0,
            total: 0.0,
            invalid: false
        }
    },
    isValid: true,
    isSubmitted: false,
    defaultAssets: []
};

let updateClientInfo = (state, data) => {
    let newState = Object.assign({}, state);
    if(data.key === "age") {
        if(data.value === "CLICK") {
            newState.clientInfo[data.key].value = "";
            newState.clientInfo[data.key].invalid = false;
        }else if(data.value === "BLUR") {
            if (newState.clientInfo[data.key].value === "" || !Number.isInteger(parseInt(newState.clientInfo[data.key].value))) {
                newState.clientInfo["dateOfBirth"].value = convertAgeToDateOfBirth(0);
                newState.clientInfo["dateOfBirth"].invalid = false;
                newState.clientInfo[data.key].value = 0;
                newState.clientInfo[data.key].invalid = false;
            }
        }else {
            if (data.value === "" || !Number.isInteger(parseInt(data.value))) data.value = 0;
            if (parseInt(data.value) < 0) data.value = 0;
            if (parseInt(data.value) > 110) data.value = 110;
            newState.clientInfo["dateOfBirth"].value = convertAgeToDateOfBirth(data.value);
            newState.clientInfo["dateOfBirth"].invalid = false;
            newState.clientInfo[data.key].value = data.value;
            newState.clientInfo[data.key].invalid = false;
        }
    }else {
        newState.clientInfo[data.key].value = data.value;
        newState.clientInfo[data.key].invalid = false;
    }
    return newState;
};

let updateAccountInfo = (state, value) => {
    let newState = Object.assign({}, state);

    if(value === "CLICK") {
        newState.accountInfo.value = "";
        newState.accountInfo.invalid = false;
    }else if(value === "BLUR") {
        let accountValue = parseFloat(newState.accountInfo.value);
        if (isNaN(accountValue)) {
            newState.accountInfo.value = parseFloat(0);
            newState.accountInfo.invalid = false;
        }
    }else {
        let accountValue = parseFloat(value);
        if (isNaN(accountValue)) accountValue = 0.0;
        newState.accountInfo.value = parseFloat(accountValue);
        newState.accountInfo.invalid = false;
    }

    return newState;
};

let updateAssetInfo = (state, data) => {
    let newState = Object.assign({}, state);

    let assets = state.allocation.assets.map((category) => {
        if (category.assetId !== data.categoryId) return category;
        let newCategory = Object.assign({}, category);
        newCategory.children = newCategory.children.map((asset) => {
            if (asset.assetId !== data.assetId) return asset;
            let newAsset = Object.assign({}, asset);

            let assetValue = parseFloat(data.value);
            if (!isNaN(assetValue)) {
                newAsset.value = parseFloat(assetValue);
            } else {
                if (data.value !== "BLUR") newAsset.value = "";
                if (data.value === "BLUR" && newAsset.value === "") newAsset.value = 0.0;
            }

            return newAsset;
        });

        let total = reduce((accum, asset) => {
            if (!isNaN(parseFloat(asset.value))) {
                return accum + asset.value;
            } else {
                return accum;
            }

        },0, newCategory.children);

        newCategory.value = total;

        return newCategory;
    });

    newState.allocation = {
        isDefault: state.allocation.isDefault,
        allocationId: state.allocation.allocationId,
        allocationName: state.allocation.allocationName,
        invalid: false,
        assets: assets
    };

    newState.allocation.invalid = false;
    return newState;
};

let updateIPValue = (state, value) => {
    let newState = Object.assign({}, state);

    let ip7Value = parseFloat(value);
    //if (isNaN(ip7Value)) ip7Value = 0.0;

    if (!isNaN(ip7Value)) {
        newState.IP7.percentageAllocation.value = parseFloat(ip7Value);
    } else {
        if (value !== "BLUR") newState.IP7.percentageAllocation.value = "";
        if (value === "BLUR" && newState.IP7.percentageAllocation.value === "") newState.IP7.percentageAllocation.value = 0.0;
    }


    newState.IP7.percentageAllocation.invalid = false;
    return newState;
};

let updateIndexArchieverValue = (state, value) => {
    let newState = Object.assign({}, state);

    let indexArchieverValue = parseFloat(value);
    //if (isNaN(indexArchieverValue)) indexArchieverValue = 0.0;

    if (!isNaN(indexArchieverValue)) {
        newState.IndexAchiever.percentageAllocation.value = parseFloat(indexArchieverValue);
    } else {
        if (value !== "BLUR") newState.IndexAchiever.percentageAllocation.value = "";
        if (value === "BLUR" && newState.IndexAchiever.percentageAllocation.value === "") newState.IndexAchiever.percentageAllocation.value = 0.0;
    }

    newState.IndexAchiever.percentageAllocation.invalid = false;
    return newState;
}

let validateAllocations = (allocation) => {

    // no negative values
    let allPositive = reduce((accum, category) => {

        let childAllValid = reduce((accum, asset) => {
            return accum && asset.value >= 0;
        }, true, category.children);

        return accum && childAllValid;

    }, true, allocation.assets);

    if (!allPositive) return true;

    // must add to 100%
    let total = reduce((accum, category) => {

        let childrenTotal = reduce((accum, asset) => {
            return accum + asset.value;
        }, 0, category.children);

        return accum + childrenTotal;

    }, 0, allocation.assets);

    return total !== 100.0;
};

let validateIndexAllocations = (indexAllocations) => {

    // no negative values
    if (indexAllocations.yr < 0.0) return true;
    if (indexAllocations.sandp < 0.0) return true;
    if (indexAllocations.sandrcntl < 0.0) return true;
    if (indexAllocations.retiree < 0.0) return true;
    if (indexAllocations.interestRate < 0.0) return true;
    if (indexAllocations.barclay < 0.0) return true;

    // must add to 100%
    let total = 0.0;

    total += indexAllocations.yr;
    total += indexAllocations.sandp;
    total += indexAllocations.sandrcntl;
    total += indexAllocations.retiree;
    total += indexAllocations.interestRate;
    total += indexAllocations.indexEAFE;
    total += indexAllocations.barclay;

    return total !== 100.0;
};

let validateIndexAllocationsRila = (indexAllocations) => {

    // no negative values
    if (indexAllocations.sp500Minus10Percentage < 0.0) return true;
    if (indexAllocations.sp500OneYear50Percentage < 0.0) return true;
    if (indexAllocations.sp500OneYear10Percentage < 0.0) return true;
    if (indexAllocations.sp500SixYear10Percentage < 0.0) return true;
    if (indexAllocations.eafeOneYear50Percenpage < 0.0) return true;
    if (indexAllocations.eafeOneYear10Percenpage < 0.0) return true;
    if (indexAllocations.realEstateOneYear50Percentage < 0.0) return true;
    if (indexAllocations.realEstateOneYear10Percentage < 0.0) return true;
    if (indexAllocations.spdrOneYear50Percentage < 0.0) return true;
    if (indexAllocations.spdrOneYear10Percentage < 0.0) return true;

    // must add to 100%
    let total = 0.0;

    total += indexAllocations.sp500Minus10Percentage;
    total += indexAllocations.sp500OneYear50Percentage;
    total += indexAllocations.sp500OneYear10Percentage;
    total += indexAllocations.sp500SixYear10Percentage;
    total += indexAllocations.eafeOneYear50Percenpage;
    total += indexAllocations.eafeOneYear10Percenpage;
    total += indexAllocations.realEstateOneYear50Percentage;
    total += indexAllocations.realEstateOneYear10Percentage;
    total += indexAllocations.spdrOneYear50Percentage;
    total += indexAllocations.spdrOneYear10Percentage;

    return total !== 100.0;
};

let validatePlanInfo = (state, type) => {
    let newState = Object.assign({}, state);

    newState.clientInfo.firstName.invalid = (newState.clientInfo.firstName.value === "");
    newState.clientInfo.lastName.invalid = (newState.clientInfo.lastName.value === "");
    newState.clientInfo.dateOfBirth.invalid = (newState.clientInfo.dateOfBirth.value === "");
    newState.clientInfo.state.invalid = (newState.clientInfo.state.value === "");
    newState.accountInfo.invalid = (newState.accountInfo.value <= 0 || newState.accountInfo.value > 2000000);

    if (newState.allocation.isDefault) {
        newState.allocation.invalid = (newState.allocation.allocationId === null) || newState.allocation.allocationId === "CHOOSE";
    } else {
        newState.allocation.invalid = validateAllocations(newState.allocation);
    }

    newState[type].percentageAllocation.invalid = (newState[type].percentageAllocation.value <= 0 || newState[type].percentageAllocation.value > 100.0);
    if (type.indexOf("IndexAchiever") === -1) {
        newState[type].indexAllocation.invalid = validateIndexAllocations(newState[type].indexAllocation);
    } else {
        newState[type].indexAllocation.invalid = validateIndexAllocationsRila(newState[type].indexAllocation);
    }

    let isInvalid = newState.clientInfo.firstName.invalid ||
        newState.clientInfo.lastName.invalid ||
        newState.clientInfo.dateOfBirth.invalid ||
        newState.clientInfo.state.invalid ||
        newState.accountInfo.invalid ||
        newState.allocation.invalid ||
        newState[type].percentageAllocation.invalid ||
        newState[type].indexAllocation.invalid;

    newState.isValid = !isInvalid;

    return newState;
};

let updateAllocationId = (state, allocationId) => {
    let newState = Object.assign({}, state);

    if (allocationId === "CHOOSE") {
        newState.allocation.allocationId = allocationId;
        return newState;
    }

    let model = find(propEq('allocationModelId', parseInt(allocationId, 10)))(newState.allocationList);
    newState.allocation.allocationId = model.allocationModelId;
    newState.allocation.allocationName = model.allocationModelName;
    newState.allocation.assets = Array.from(model.assets);
    newState.allocation.invalid = false;

    return newState;
};

let updateAllocationType = (state, isDefault) => {
    let newState = Object.assign({}, state);
    newState.allocation.isDefault = isDefault;
    newState.allocation.invalid = false;

    if (isDefault) {
        newState.allocation.allocationId = "CHOOSE";
    } else {
        newState.allocation.allocationId = null;
        newState.allocation.allocationName = "Custom Allocation";
        newState.allocation.assets = Array.from(state.defaultAssets);
    }

    return newState;
};


let parseFloatOrZero = (value, lastValue) => {
    let result = parseFloat(value);

    if (!isNaN(result)) return result;

    if (value !== "BLUR") return "";
    if (value === "BLUR" && lastValue === "") return 0.0;
    return parseInt(lastValue);
};

let updateIndexAllocations = (state, data) => {
    let newState = Object.assign({}, state);

    newState.IP7.indexAllocation = {
        yr: parseFloatOrZero(data.yr, state.IP7.indexAllocation.yr),
        sandp: parseFloatOrZero(data.sandp, state.IP7.indexAllocation.sandp),
        sandrcntl: parseFloatOrZero(data.sandrcntl, state.IP7.indexAllocation.sandrcntl),
        retiree: parseFloatOrZero(data.retiree, state.IP7.indexAllocation.retiree),
        interestRate: parseFloatOrZero(data.interestRate, state.IP7.indexAllocation.interestRate),
        indexEAFE: parseFloatOrZero(data.indexEAFE, state.IP7.indexAllocation.indexEAFE),
        barclay: parseFloatOrZero(data.barclay, state.IP7.indexAllocation.barclay),
        total: 0.0,
        invalid: false
    };


    if (newState.IP7.indexAllocation.yr !== "") newState.IP7.indexAllocation.total += newState.IP7.indexAllocation.yr;
    if (newState.IP7.indexAllocation.sandp !== "") newState.IP7.indexAllocation.total += newState.IP7.indexAllocation.sandp;
    if (newState.IP7.indexAllocation.sandrcntl !== "") newState.IP7.indexAllocation.total += newState.IP7.indexAllocation.sandrcntl;
    if (newState.IP7.indexAllocation.retiree !== "") newState.IP7.indexAllocation.total += newState.IP7.indexAllocation.retiree;
    if (newState.IP7.indexAllocation.interestRate !== "") newState.IP7.indexAllocation.total += newState.IP7.indexAllocation.interestRate;
    if (newState.IP7.indexAllocation.indexEAFE !== "") newState.IP7.indexAllocation.total += newState.IP7.indexAllocation.indexEAFE;
    if (newState.IP7.indexAllocation.barclay !== "") newState.IP7.indexAllocation.total += newState.IP7.indexAllocation.barclay;

    return newState;
};

let updateIndexAllocationsRILA = (state, data) => {
    let newState = Object.assign({}, state);

    newState.IndexAchiever.indexAllocation = {
        sp500Minus10Percentage: parseFloatOrZero(data.sp500Minus10Percentage, state.IndexAchiever.indexAllocation.sp500Minus10Percentage),
        sp500OneYear50Percentage: parseFloatOrZero(data.sp500OneYear50Percentage, state.IndexAchiever.indexAllocation.sp500OneYear50Percentage),
        sp500OneYear10Percentage: parseFloatOrZero(data.sp500OneYear10Percentage, state.IndexAchiever.indexAllocation.sp500OneYear10Percentage),
        sp500SixYear10Percentage: parseFloatOrZero(data.sp500SixYear10Percentage, state.IndexAchiever.indexAllocation.sp500SixYear10Percentage),
        eafeOneYear50Percenpage: parseFloatOrZero(data.eafeOneYear50Percenpage, state.IndexAchiever.indexAllocation.eafeOneYear50Percenpage),
        eafeOneYear10Percenpage: parseFloatOrZero(data.eafeOneYear10Percenpage, state.IndexAchiever.indexAllocation.eafeOneYear10Percenpage),
        realEstateOneYear50Percentage: parseFloatOrZero(data.realEstateOneYear50Percentage, state.IndexAchiever.indexAllocation.realEstateOneYear50Percentage),
        realEstateOneYear10Percentage: parseFloatOrZero(data.realEstateOneYear10Percentage, state.IndexAchiever.indexAllocation.realEstateOneYear10Percentage),
        spdrOneYear50Percentage: parseFloatOrZero(data.spdrOneYear50Percentage, state.IndexAchiever.indexAllocation.spdrOneYear50Percentage),
        spdrOneYear10Percentage: parseFloatOrZero(data.spdrOneYear10Percentage, state.IndexAchiever.indexAllocation.spdrOneYear10Percentage),
        total: 0.0,
        invalid: false
    };

    if (newState.IndexAchiever.indexAllocation.sp500Minus10Percentage !== "") newState.IndexAchiever.indexAllocation.total += newState.IndexAchiever.indexAllocation.sp500Minus10Percentage;
    if (newState.IndexAchiever.indexAllocation.sp500OneYear50Percentage !== "") newState.IndexAchiever.indexAllocation.total += newState.IndexAchiever.indexAllocation.sp500OneYear50Percentage;
    if (newState.IndexAchiever.indexAllocation.sp500OneYear10Percentage !== "") newState.IndexAchiever.indexAllocation.total += newState.IndexAchiever.indexAllocation.sp500OneYear10Percentage;
    if (newState.IndexAchiever.indexAllocation.sp500SixYear10Percentage !== "") newState.IndexAchiever.indexAllocation.total += newState.IndexAchiever.indexAllocation.sp500SixYear10Percentage;
    if (newState.IndexAchiever.indexAllocation.eafeOneYear50Percenpage !== "") newState.IndexAchiever.indexAllocation.total += newState.IndexAchiever.indexAllocation.eafeOneYear50Percenpage;
    if (newState.IndexAchiever.indexAllocation.eafeOneYear10Percenpage !== "") newState.IndexAchiever.indexAllocation.total += newState.IndexAchiever.indexAllocation.eafeOneYear10Percenpage;
    if (newState.IndexAchiever.indexAllocation.realEstateOneYear50Percentage !== "") newState.IndexAchiever.indexAllocation.total += newState.IndexAchiever.indexAllocation.realEstateOneYear50Percentage;
    if (newState.IndexAchiever.indexAllocation.realEstateOneYear10Percentage !== "") newState.IndexAchiever.indexAllocation.total += newState.IndexAchiever.indexAllocation.realEstateOneYear10Percentage;
    if (newState.IndexAchiever.indexAllocation.spdrOneYear50Percentage !== "") newState.IndexAchiever.indexAllocation.total += newState.IndexAchiever.indexAllocation.spdrOneYear50Percentage;
    if (newState.IndexAchiever.indexAllocation.spdrOneYear10Percentage !== "") newState.IndexAchiever.indexAllocation.total += newState.IndexAchiever.indexAllocation.spdrOneYear10Percentage;

    return newState;
};

let updateClientId = (state, data) => {
    let newState = Object.assign({}, state);
    newState.clientInfo.clientId = data;
    return newState;
};

let updateAllocationList = (state, data) => {
    let newState = Object.assign({}, state);
    newState.allocationList = data;
    return newState;
};

let updateDefaultAssets = (state, data) => {
    let newState = Object.assign({}, state);
    newState.defaultAssets = data.map((cat) => {
        cat.value = 0;

        cat.children = cat.children.map((child) => {
            child.value = 0;
            return child;
        });

        return cat;
    });
    return newState;
};

let updateIsValid = (state, data) => {
    let newState = Object.assign({}, state);
    newState.isValid = data;
    return newState;
};

let submitPlanInfo = (state) => {
    let newState = Object.assign({}, state);
    newState.isSubmitted = true;
    return newState;
};

let clearPlanSubmit = (state) => {
    let newState = Object.assign({}, state);
    newState.isSubmitted = false;
    return newState;
};

const planInfoReducer = (state = initialState, action) => {
    if (action.type === actionTypes.CLIENTINFO_UPDATE) {
        return updateClientInfo(state, action.data);
    }

    if (action.type === actionTypes.ACCOUNT_UPDATE) {
        return updateAccountInfo(state, action.value);
    }

    if (action.type === actionTypes.ASSET_UPDATE) {
        return updateAssetInfo(state, action.data);
    }

    if (action.type === actionTypes.IP7PERCENTAGE_UPDATE) {
        return updateIPValue(state, action.value);
    }

    if (action.type === actionTypes.INDEXARCHIEVERPERCENTAGE_UPDATE) {
        return updateIndexArchieverValue(state, action.value);
    }

    if (action.type === actionTypes.VALIDATE_PLANINFO) {
        return validatePlanInfo(state, action.value);
    }

    if (action.type === actionTypes.UPDATE_ALLOCATION_ID) {
        return updateAllocationId(state, action.allocationId);
    }

    if (action.type === actionTypes.UPDATE_ALLOCATION_TYPE) {
        return updateAllocationType(state, action.isDefault);
    }

    if (action.type === actionTypes.UPDATE_INDEX_ALLOCATIONS) {
        return updateIndexAllocations(state, action.data);
    }

    if (action.type === actionTypes.UPDATE_INDEX_ALLOCATIONS_RILA) {
        return updateIndexAllocationsRILA(state, action.data);
    }

    if (action.type === actionTypes.UPDATE_CLIENT_ID) {
        return updateClientId(state, action.data);
    }

    if (action.type === actionTypes.UPDATE_ALLOCATION_LIST) {
        return updateAllocationList(state, action.data);
    }

    if (action.type === actionTypes.UPDATE_DEFAULT_ASSETS) {
        return updateDefaultAssets(state, action.data);
    }

    if (action.type === actionTypes.UPDATE_IS_VALID) {
        return updateIsValid(state, action.isValid);
    }

    if (action.type === actionTypes.SUBMITTED_PLAN_INFO) {
        return submitPlanInfo(state);
    }

    if (action.type === actionTypes.CLEAR_PLANINFO_SUBMITTED) {
        return clearPlanSubmit(state);
    }

    return state;
};

export default planInfoReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/planInfo.js